export default {
  Codigo: null,
  CodigoOrdenProduccion: null,
  ItemCantidad: 1,
  Cantidad: null,
};
